










































































































































































































































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';

import Viewpoints from '@/store/modules/Viewpoints';
import Decisions from '@/store/modules/Decisions';
import Scoring from '@/store/modules/Scoring';
import Choices from '@/store/modules/Choices';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import FactorScoringDefinitionCreator from '@/components/scoring-definition/FactorScoringDefinitionCreator.vue';
import ViewpointFactorScore from '@/components/scoring-input/ViewpointFactorScore.vue';
import FactorValueDisplay from '@/components/common/FactorValueDisplay.vue';
import { NotificationEventBus } from '@/EventBus';
import ChoiceFactorInputMenu from '@/components/choice-input/ChoiceFactorInputMenu.vue';
import ScoringKeys from '@/store/modules/ScoringKeys';
import _ from 'lodash';
import { FactorGroup } from '@/api/model/FactorResource';
import Modelling from '@/store/modules/Modelling';
import { Viewpoint } from '@/api/model/Viewpoint';

const modellingModule = getModule(Modelling);
const viewpointsModule = getModule(Viewpoints);
const decisionsModule = getModule(Decisions);
const scoringModule = getModule(Scoring);
const choicesModule = getModule(Choices);
const workspaceOptionsModule = getModule(WorkspaceOptions);
@Component({
    components: {
        MenuFactorValueEditor: ChoiceFactorInputMenu,
        FactorValueDisplay,
        ViewpointFactorScore,
        FactorScoringDefinitionCreator,
    },
})
export default class TableScoreInput extends Vue {
    @Prop({ default: 0, type: Number })
    factorLevel!: number;
    
    @Prop()
    tableFactorGroup!: FactorGroup;

    @Prop()
    sortedViewpoints: Viewpoint[];

    private selectedColumnId: string | null = null;

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get selectedViewpoints() {
        return viewpointsModule.selectedViewpoints;
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources;
    }

    get selectedChoice() {
        return choicesModule.selectedChoice;
    }

    get scoredChoices() {
        return scoringModule.viewpointScores;
    }

    get viewpointChoiceFactors() {
        return viewpointsModule.viewpointChoiceFactorResource;
    }

    get orderedRows(): FactorGroup[] {
        return this.tableFactorGroup.childrenIds
            .map((f) => this.factorResources[f] as FactorGroup)
            .filter((f) => f && f.groupTypeDefinition.type === 'TABLE_ROW');
    }

    get orderedColumns(): FactorGroup[] {
        if( this.tableFactorGroup && this.tableFactorGroup.childrenIds ){
            let orderedColumns = this.tableFactorGroup.childrenIds
            .map((f) => this.factorResources[f] as FactorGroup)
            .filter((f) => f && f.groupTypeDefinition.type === 'TABLE_COLUMN');
            if( orderedColumns && orderedColumns.length > 0 ){
                this.selectedColumnId = orderedColumns[0].id;
            }
            return orderedColumns;
        }else{
            return null;
        }
    }

    get tableGrid() {
        let grid: any = {};
        this.orderedColumns.forEach((c) => {
            grid[c.id] = {};
            this.orderedRows.forEach((r) => {
                let factorIds = _.intersection(c.childrenIds, r.childrenIds);
                if (factorIds.length === 1) {
                    grid[c.id][r.id] = factorIds[0];
                }
            });
        });
        return grid;
    }

    get contributingVisibility() {
        return workspaceOptionsModule.contributingFactorVisibility;
    }

    get contributingFactorResources() {
        return viewpointsModule.contributingFactorResources;
    }

    get factorListTree() {
        return modellingModule.factorListTree;
    }

    get isFactorListActive() {
        return workspaceOptionsModule.activeFactorLists.length > 0;
    }

    get columnWidths() {
        if (Object.keys(workspaceOptionsModule.viewpointsColumnWidth).length === 0) {
            workspaceOptionsModule.changeViewpointColumnWidth(150);
        }
        return workspaceOptionsModule.viewpointsColumnWidth;
    }
    get viewpointFirstCol() {
        return workspaceOptionsModule.viewpointFirstCol;
    }

    get showNonListFactors() {
        return workspaceOptionsModule.showNonListFactors;
    }

    get leftCol() {
        let children = this.orderedColumns;
        let indexOfSelected = _.findIndex(children, ((val) => val.id === this.selectedColumnId))
        if(indexOfSelected === 0) {
            return children[children.length - 1].id
        }
        else {
            return children[indexOfSelected - 1].id
        }
    }

    get rightCol() {
        let children = this.orderedColumns;
        let indexOfSelected = _.findIndex(children, ((val) => val.id === this.selectedColumnId))
        if(indexOfSelected === children.length - 1) {
            return children[0].id
        }
        else {
            return children[indexOfSelected + 1].id
        }
    }

    get editComments() {
        return workspaceOptionsModule.editComments;
    }

    private isFactorVisible(resourceId: string) {
        if (this.showNonListFactors || !this.isFactorListActive) {
            // return  this.contributingVisibility || (!this.contributingVisibility  && (!this.contributingFactorResources[resourceId] || this.contributingFactorResources[resourceId].numWeightingDots > 0))
            return true;
        } else {
            if (
                this.isFactorListActive &&
                this.factorListTree[resourceId] &&
                !this.showNonListFactors
            ) {
                return true;
            } else return false;
        }
    }

    getViewpointCellFactor(rowId: string, viewpointId: string) {
        let factor;
        if (this.selectedColumnId) {
            factor = this.tableGrid[(this.selectedColumnId, rowId)];
        } else {
            factor = this.factorResources[rowId];
        }

        if (
            this.viewpointChoiceFactors[viewpointId] &&
            this.viewpointChoiceFactors[viewpointId][this.selectedChoice.choiceId] &&
            this.viewpointChoiceFactors[viewpointId][this.selectedChoice.choiceId][factor.id] &&
            this.viewpointChoiceFactors[viewpointId][this.selectedChoice.choiceId][factor.id].score
        ) {
            return this.viewpointChoiceFactors[viewpointId][this.selectedChoice.choiceId][
                factor.id
            ];
        }

        return this.scoredChoices[viewpointId].choiceScores[this.selectedChoice.id]
            .choiceFactorScores[factor.id];
    }

    private async updateChoiceData(value: any, factor: any) {
        if (this.selectedChoice[factor.dataField] === value) return;
        NotificationEventBus.emitProcessingMessage();
        try {
            await choicesModule.updateChoiceField({
                choiceId: this.selectedChoice.id,
                value: value,
                factorResourceId: factor.id,
                refreshScoring: false,
            });
            NotificationEventBus.emitSuccessMessage();
            scoringModule.refreshScoring();
        } catch (e) {
            NotificationEventBus.emitFailedMessage(e);
        }
    }

    private scoringDefinitionForm: ScoringDefinitionForm | null = null;
    private showScoringDefinitionEditor = false;
    private updating = false;

    private get isRowsCustom() {
        let groupTypeDefinitions = this.orderedColumns
            .map((fg: any) => fg.groupTypeDefinition)
            .filter((gtd: any) => gtd != null);

        return groupTypeDefinitions.length === 0;
    }

    private get isColumnsCustom() {
        let groupTypeDefinitions = this.orderedRows
            .map((fg: any) => fg.groupTypeDefinition)
            .filter((gtd: any) => gtd != null);

        return groupTypeDefinitions.length === 0;
    }

    private scoringDefinitionClick(group: FactorGroup) {
        let scoringKeys = !getModule(ScoringKeys).workingModelScoringKeyDefinitions;
        let aFactor = _.first(group.childrenIds.map((f) => this.factorResources[f])) as any;
        let factorScoringKey;
        if (aFactor && scoringKeys && scoringKeys[aFactor.id]) {
            factorScoringKey = scoringKeys[aFactor.id];
        } else {
            factorScoringKey = { inheritedFrom: null, scoringKeys: null };
        }

        this.scoringDefinitionForm = {
            id: group.id,
            name: group.name,
            inheritedFromName: aFactor ? factorScoringKey.inheritedFrom : null,
            scoringKeys: aFactor ? factorScoringKey.scoringKeys : null,
            valuePrefix: group.groupTypeDefinition.valuePrefix,
            valueSuffix: group.groupTypeDefinition.valueSuffix,
            valueType: group.groupTypeDefinition.valueType,
            scoringDefinition: aFactor ? aFactor.scoringDefinition : {},
        };
        this.showScoringDefinitionEditor = true;
    }

    private submitScoringDefinition(groupId: string, scoringDefinition: any) {
        //
        // if (!scoringDefinition) return;
        // let scoringDefinitionCopy = JSON.parse(JSON.stringify(scoringDefinition))
        //
        // let factors = Object.values(this.selectedDraftFactors)
        //     .filter((f: any) => f.groups.includes(groupId))
        // factors.forEach((f: any) => f.scoringDefinition = scoringDefinitionCopy);
        // this.updating = true;
        // viewpointsModule.updateDraftFactors({
        //     viewpointId: this.selectedViewpoint.viewpointId,
        //     factors: factors
        // }).then(() => {
        //     this.showScoringDefinitionEditor = false
        //     this.updating = false;
        // }).catch(err => {
        //     this.showScoringDefinitionEditor = false
        //     this.updating = false;
        // })
    }

    private deleteScoringDefinition(groupId: string) {
        // let factors = Object.values(this.selectedDraftFactors)
        //     .filter((f: any) => f.groups.includes(groupId))
        // factors.forEach((f: any) => f.scoringDefinition = null);
        // this.updating = true;
        // viewpointsModule.updateDraftFactors({
        //     viewpointId: this.selectedViewpoint.viewpointId,
        //     factors: factors
        // }).then(() => {
        //     this.showScoringDefinitionEditor = false
        //     this.updating = false;
        // }).catch(err => {
        //     this.showScoringDefinitionEditor = false
        //     this.updating = false;
        // })
    }
    private cycleLeft() {
        this.selectedColumnId = this.leftCol;
    }

    private cycleRight() {
        this.selectedColumnId = this.rightCol;
    }
}

interface ScoringDefinitionForm {
    id: string;
    name?: string;
    scoringDefinition: any;
    scoringKeys: any[] | null;
    inheritedFromName?: any;
    categoricalValues?: string[];
    valuePrefix: string;
    valueSuffix: string;
    valueType: string;
}
